import { FunctionComponent, ReactNode } from 'react';
import './Tooltip.scss';

export const Tooltip: FunctionComponent<{ children: ReactNode }> = ({ children }) => (
  <div className="tooltip">
    <div className="tooltip__arrow" />
    {children}
  </div>
);
